import UpdateButton from "./index";

function UseUpdateButton(click: () => void) {
  return <UpdateButton onClick={click}></UpdateButton>;
}

export const renderBlankHeader = () => <></>;

export default UseUpdateButton;
